(function($){
    $.fn.overflowing = function(options, callback){
        let self = this
        let overflowed = []
        let hasCallback = callback && typeof callback === 'function' ? true : false;
        let status = false
        this.options = options || window

        this.each(function(){
            if ($.isWindow(this)) return false
            let $this = $(this)
            elPosition = $this.position()
            elWidth = $this.width()
            elHeight = $this.height()
            let parents = $this.parentsUntil(self.options)
            let $parentsTo = $(self.options)
            parents.push($parentsTo)

            for(let i=0; i<parents.length; i++){
                let $parent = $(parents[i])
                if ($.isWindow($parent[0])) break
                let absPosition = !!~['absolute', 'fixed'].indexOf($parent.css('position'))
                let parentPosition = $parent.position()
                let parentWidth = $parent.width() - 24
                let parentHeight = $parent.height()
                let parentToBottom = absPosition ? parentHeight : (parentHeight+parentPosition.top)
                let parentToRight = absPosition ? parentWidth : (parentWidth+parentPosition.left)

                if ( elPosition.top < 0
                    || elPosition.left < 0
                    || elPosition.top > parentToBottom
                    || elPosition.left > parentToRight
                    || Math.floor((elPosition.top + elHeight)) > parentToBottom
                    || Math.floor((elPosition.left + elWidth)) > parentToRight) {
                    status = true
                    $(parents[i]).addClass('overflowed')
                    overflowed.push(parents[i])
                    if (hasCallback) callback(parents[i])
                }
            }

            if($this.parents(self.options).hasClass('overflowed')) $this.addClass('overflowing')
        })

        if (!hasCallback) return overflowed.length > 1 ? overflowed : status
    }
})(jQuery)